import { useContext } from 'react'
import { Store } from '../Utils/Store'

export function useStore() {
  const ctx = useContext(Store)
  if (!ctx) {
    throw new Error('useStore must be used within StoreProvider')
  }
  return ctx
}
